module.exports = __webpack_public_path__ + "img/ribbon-white.876367f1.png";